var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "list_item" }, [
    _c(
      "a",
      {
        staticClass: "link_item thumb_info_type",
        attrs: { href: _vm.cafeLink, target: "_blank" },
      },
      [
        _c("div", { staticClass: "box_num" }, [
          _c("span", { staticClass: "num_item" }, [
            _vm._v(_vm._s(_vm.rank + 1)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wrap_thumb" }, [
          _c("img", {
            staticClass: "img_thumb",
            attrs: { src: _vm.cafeImage, alt: "" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "tag_cafe_ico" }, [
            _vm.cafeInfo.gameCafe
              ? _c("span", { staticClass: "svg_game" }, [
                  _c("span", { staticClass: "sr_only" }, [_vm._v("게임카페")]),
                ])
              : _vm.cafeInfo.popularCafe
              ? _c("span", { staticClass: "svg_great" }, [
                  _c("span", { staticClass: "sr_only" }, [_vm._v("인기카페")]),
                ])
              : _vm.cafeInfo.officialFanCafe
              ? _c("span", { staticClass: "svg_fan" }, [
                  _c("span", { staticClass: "sr_only" }, [_vm._v("팬카페")]),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wrap_info", class: _vm.infoClass }, [
          _c("strong", { staticClass: "tit_name" }, [
            _vm._v(_vm._s(_vm.cafeInfo.grpname)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc_cafe" }, [
            _vm._v(_vm._s(_vm.cafeInfo.grpdesc)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tag_type_info" }, [
            _c("span", { staticClass: "txt_info" }, [
              _vm._v(
                _vm._s(_vm.cafeInfo.cafeLevelName) +
                  " " +
                  _vm._s(_vm.cafeInfo.cafeLevel) +
                  "단계"
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "txt_info" }, [
              _c("em", { staticClass: "screen_out" }, [_vm._v("점수")]),
              _vm._v(_vm._s(_vm.cafeScore) + "점"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "txt_info" }, [
              _c("em", [_vm._v("회원수 ")]),
              _vm._v(_vm._s(_vm.cafeMemberCnt)),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }